export const shouldForwardProp =
  (props: PropertyKey[]) =>
    (prop: PropertyKey): boolean =>
      !props.includes(prop as PropertyKey)
